// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-221c36eb]{text-indent:-99999em;overflow:hidden;background:0 0 no-repeat;width:230px;height:80px;background-size:contain;margin:auto;display:block;margin-bottom:2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
